<template>
    <div class="payment-wrap">

        <ChangeBillingCycle
            variant="upgrade"
            @subscriptionLoaded="onSubscriptionLoaded"
            @changedCycle="onCycleChanged" />
            
        <div class="subscriptions-main-actions">
            <GekkoButton
                @click="cancelUpgrade"
                :text="$gettext('Cancel')"
                variant="link"
                class="mr-2"
            />
            <GekkoButton
                @click="save"
                :text="$gettext('Pay')"
                size="lg"
                class="px-4"
            />
        </div>

    </div>
</template>

<script>
import GekkoButton from '@/components/GekkoButton.vue';
import ChangeBillingCycle from '@/components/subscriptions/ChangeBillingCycle.vue';
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "UpgradeSubscription",
    components: { ChangeBillingCycle, GekkoButton },
    mixins: [settingsPageSetup],
    data() {
        return {
            pageSettings: {
                title: this.$gettext("Change your billing cycle"),
                showCompanyPicker: false
            },
            subscription: this.$store.getters['subscriptionStore/getSubscription']
        }
    },
    created() {
        /* TODO: title of the page must change depending on the subscription type
            this implementation doesn't work but contains the logic
        */
       
        if (this.$store.getters['getIsPremium'])
            this.pageSettings.title = this.$gettext("Change your billing cycle");
        else
            this.pageSettings.title = this.$gettext("Upgrading to premium");
    },
    methods: {
        cancelUpgrade() {
            this.$router.push({name: "Subscriptions"});
        }
        /*
        TODO: CHECK WHEN A TRANSACTION IS ALREADY INITIALIZED (add team members)
        getNumberOfUsers(subscriptionType) {
            if(!vm.subscription){
                return 0;
            }
            if(subscriptionType=='oldSubscription'){
                return vm.old_subscription.number_of_extra_connected_and_pending_users || 0 ;
            }
            else{
                var numberOfUser = vm.subscription.number_of_extra_connected_and_pending_users || 0;
                if(vm.transaction.extra_users){
                    numberOfUser += vm.transaction.extra_users;
                }
                return numberOfUser;
            }
        }
        */
    }
}
</script>

<style lang="scss" scoped>
.payment-wrap {
    @media(max-width: '650px') {
        padding-bottom: 100px;
    }
}
</style>
<style lang="scss">
.subscriptions-main-actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-self: flex-end;
    margin-top: 1rem;

    @media(max-width: '767px') {
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 10;
        background: white;
        padding: 0.75rem 1rem;
        box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 10%) 0px -4px 6px -1px, rgb(0 0 0 / 6%) 0px -2px 4px -1px;
    }
    &.single-btn {
        justify-content: flex-end;
        @media(max-width: '650px') {
            justify-content: center;
        }
    }
}
</style>
